import { Component, OnInit, ViewChild, Input, TemplateRef } from '@angular/core';
import { CrawfordGridComponent, GridColumn, CrawfordSnackbarService, DateFormat, CrawfordSpinnerService,
         CrawfordApiGridAdaptor, ApiGridParameters, ITabComponent, CrawfordDownloadService } from 'crawford-shell';

import { CommunicationService } from '../communication.service';
import { ActivatedRoute } from '@angular/router';
import { eventListData } from '../data/event-list.source';
import { DataManager } from '@syncfusion/ej2-data';
import { PageSettingsModel } from '@syncfusion/ej2-grids';
import { EventDetail } from '../model/event-detail.model';
import { Event } from '../model/event.model';

@Component({
  selector: 'app-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.scss']
})
export class DocumentListComponent implements OnInit, ITabComponent {

  @Input() public crawfordRef: string;

  @ViewChild('ccogrid') public ccoGrid: CrawfordGridComponent;
  @ViewChild('templateIcon') templateIconRef: TemplateRef<any>;

  public adaptor: CrawfordApiGridAdaptor;
  public dataSource: DataManager;
  public gridData: Event[];
  public dataLoaded: boolean;

  public df: DateFormat = {
    type: 'date',
    format: 'dd/MM/yyyy HH:mm'
  };

  public displayColumns: GridColumn[] = [];

  public sortingSettings: any = {
    columns: [{field: 'date', direction: 'descending' }]
  };

  public pageSettings: PageSettingsModel = {
    pageSize: 10
  };

  public toolbarSettings: string[] = ['Search'];

  constructor(
    private communicationService: CommunicationService,
    private snackbarService: CrawfordSnackbarService,
    private downloadService: CrawfordDownloadService,
    private spinnerService: CrawfordSpinnerService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      if (params.id) {
        this.crawfordRef = params.id;
        this.dataLoaded = false;
      }
    });

    this.displayColumns = [
      new GridColumn('id', 'EventId', { visible: false }),
      new GridColumn('name', 'Event'),
      new GridColumn('documentName', 'Document'),
      new GridColumn('documentType', 'Document Type', { template: this.templateIconRef }),
      new GridColumn('party', 'Party'),
      new GridColumn('date', 'Date', { type: 'date', format: this.df }),
      new GridColumn('category', 'Category'),
      new GridColumn('additionalInfo', 'Additional Info', { visible: false, showInColumnChooser: false })
    ];
  }

  loadData(): void {
    if (!this.dataLoaded) {
      this.spinnerService.show('claimDocumentListSpinner');
      this.adaptor = this.initalizeAdaptor();
      this.createGridData();
      this.dataLoaded = true;
    }
  }

  private initalizeAdaptor(): CrawfordApiGridAdaptor {
    const parameters = new ApiGridParameters();
    parameters.top = this.pageSettings.pageSize;
    parameters.orderBy.columnName = this.sortingSettings.columns[0].field;
    parameters.orderBy.direction = this.sortingSettings.direction;

    return new CrawfordApiGridAdaptor(parameters);
  }

  createGridData() {
    this.communicationService.getDocuments(this.crawfordRef).subscribe(events => {
      if (events) {
         events.forEach((event) => {
          if (event.documentType) {
            event.additionalInfo = this.getAdditionalInfo(event.documentType, event.date);
            event.documentType = this.updateDocumentTypeToIcon(event.documentType);
          }
         });
        this.gridData = events;
      }
    });
  }

  public getAdditionalInfo(documentType: string, documentDate: Date): string {
    let retVal = '';
    const types = this.communicationService.documentType;

    if (documentType) {

      const type = types[documentType.toLowerCase()] ? types[documentType.toLowerCase()] : types['default'];

      if (type && type.synonyms.length) {
        retVal += type.synonyms.reduce((accumulator, currentVal) => accumulator += ', ' + currentVal);
      }
    }

    if (documentDate) {
    const date = new Date(documentDate);
      retVal += ' ' + date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    }

    return retVal;
  }

  public updateDocumentTypeToIcon(documentType: string): string {
    const types = this.communicationService.documentType;
    const docType = documentType.toLowerCase();
    return types[docType] ? types[docType].icon : types['default'].icon;
  }

  public openDocument(event: any) {
    this.communicationService.getOpenDocument(this.crawfordRef, event.data.id.toString()).subscribe(response => {
      if (response) {
        this.downloadService.downloadFileFromResponse(response, event.data.documentName);
      } else {
        this.snackbarService.displayErrorMessage('Unable to download document ' + event.documentName);
      }
    });
  }

  onRowDataBound($event): void {
    const data = $event.data;
    const row = $event.row;

    if (data.documentLink) {
      row.classList.add('selectable-row');
    }
  }

  onDataBound($event: any): void {
    this.spinnerService.hide('claimDocumentListSpinner');
  }

  onActionFailure($event): void {
    this.snackbarService.displayErrorMessage($event.error);
    this.spinnerService.hide('claimDocumentListSpinner');
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/communication/document-list/document-list.component.ts